import { render, staticRenderFns } from "./priceStrategyList.vue?vue&type=template&id=31a0054a"
import script from "./priceStrategyList.vue?vue&type=script&lang=js"
export * from "./priceStrategyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports